
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ScarabIcon } from '../constants';
import { SiteContent } from '../content';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Shop', path: '/shop' },
    { name: 'Goals', path: '/goals' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-700 ${
        scrolled ? 'bg-white/95 backdrop-blur-md py-3 md:py-4 shadow-xl' : 'bg-[#F5F0E6] py-6 md:py-8'
      }`}>
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 flex justify-between items-center">
          {/* Logo Section */}
          <Link to="/" className="flex items-center space-x-3 md:space-x-4 group z-[102] relative">
            <ScarabIcon className="w-8 h-8 md:w-10 md:h-10 text-[#1A1A1A] group-hover:text-[#A65D3F] transition-all duration-500 transform group-hover:scale-110" />
            <div className="flex flex-col leading-[1.1]">
              <span className="font-condensed font-black text-xl md:text-2xl uppercase tracking-wider text-[#1A1A1A]">EARTH RIGHTS</span>
              <span className="text-[9px] md:text-[10px] font-black uppercase tracking-[0.5em] text-[#A65D3F] mt-1">Business</span>
            </div>
          </Link>
          
          {/* Desktop Navigation Menu */}
          <div className="hidden md:flex space-x-8 lg:space-x-12 items-center">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[11px] uppercase tracking-[0.25em] font-black transition-all duration-300 hover:text-[#A65D3F] relative group/link ${
                  location.pathname === link.path ? 'text-[#A65D3F]' : 'text-[#1A1A1A]'
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-2 left-0 w-0 h-0.5 bg-[#A65D3F] transition-all duration-500 group-hover/link:w-full ${
                  location.pathname === link.path ? 'w-full' : ''
                }`} />
              </Link>
            ))}
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="md:hidden z-[102] relative text-[#1A1A1A] p-2 focus:outline-none"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <div className={`w-6 h-0.5 bg-current mb-1.5 transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <div className={`w-6 h-0.5 bg-current mb-1.5 transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`} />
            <div className={`w-6 h-0.5 bg-current transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-[#F5F0E6] z-[101] flex flex-col items-center justify-center transition-all duration-500 ${
        mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}>
        <div className="flex flex-col items-center space-y-8">
          {navLinks.map((link, i) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-2xl font-condensed font-black uppercase tracking-widest transition-all duration-500 transform ${
                mobileMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              } hover:text-[#A65D3F]`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {link.name}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;
